import { useState } from "react";

/** A small pill linking to the chant's sheet music.
 *  If `href` is given (e.g. the choir's Notion page, which has PDF + MuseScore +
 *  the separate voices), it goes there. Otherwise it searches the web for a PDF. */
export function ScoreLink({ title, query, href }: { title: string; query?: string; href?: string }) {
  const [hover, setHover] = useState(false);
  if (!title.trim() && !query?.trim() && !href) return null;
  const terms = (query || `"${title}" partition`) + " filetype:pdf";
  const url = href || "https://www.google.com/search?q=" + encodeURIComponent(terms);
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label={href ? `Partition et voix de « ${title} » sur le site de la chorale` : `Chercher la partition PDF de « ${title} »`}
      title={href ? "Partition + voix — site de la chorale" : "Chercher la partition (PDF)"}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6, textDecoration: "none",
        fontFamily: "var(--font-ui)", fontSize: "var(--text-sm)", fontWeight: 600,
        color: "var(--accent-text)", background: hover ? "var(--accent-soft)" : "var(--bg-raised)",
        border: "1px solid var(--accent-ring)", borderRadius: "var(--radius-pill)",
        padding: "4px 11px 4px 9px",
        transition: "background var(--dur-fast) var(--ease-out)",
      }}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
        <path d="M14 3v5h5" />
        <path d="M9 13.5h6M9 16.5h6" />
      </svg>
      {href ? "Partition ♪" : "Partition"}
    </a>
  );
}
